import * as fp from 'lodash/fp';
import { connect } from 'react-redux';
import CategorySummaryView from './CategorySummary';
import selectAndProjectState from './CategorySummary.selectors';
import {
  receiveGridViewDefn,
} from './CategorySummary.slice';
import { StateProjection } from './CategorySummary.selectors';
import { wrappedDispatch, WrappedThunkDispatch } from 'src/utils/Redux/Dispatch';
import { makePrintSensitive } from 'src/components/higherOrder/Print/PrintSenstive';
import { TenantConfigViewData } from 'src/dao/tenantConfigClient';

import { CategorySummaryOwnProps } from 'src/services/configuration/codecs/ownProps';
function mergeProps(
  mappedState: StateProjection,
  dispatchProps: WrappedThunkDispatch,
  ownProps: CategorySummaryOwnProps,
) {
  const { dispatch } = dispatchProps;
  const { defns } = ownProps;

  return {
    ...mappedState,
    groupByDefn: defns.subheader.groupBy,

    onConfigUpdate(config: TenantConfigViewData) {
      dispatch(receiveGridViewDefn(config));
    },
  };
}

const sensitiveView = fp.flow(() => CategorySummaryView, makePrintSensitive)();

export default connect(selectAndProjectState, wrappedDispatch, mergeProps)(sensitiveView);
